import { Component } from '@angular/core';
import { COMPANY_PHONE_NUMBER } from 'src/app/constants/app.constants';
import { AuthManagerService } from 'src/app/services/auth-manager/auth-manager.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-lost-and-found',
  templateUrl: './lost-and-found.component.html',
  styleUrls: ['./lost-and-found.component.scss']
})
export class LostAndFoundComponent {
  isAuthenticated: boolean;

  public COMPANY_PHONE_NUMBER = COMPANY_PHONE_NUMBER;

  constructor(
    public authManager: AuthManagerService,
    public userService: UserService,
  ) {
    this.isAuthenticated = authManager.isAuthenticated;
  }

}
